import React from 'react';
import Btn from '../Common/Btn';

const ContentCardLeft = (props) => {
    return ( 
        <section className='ContentCardLeft'>
                        <div className='Countdown'>
                            <div className='CountText'>
                                <p className='CountTitle'>
                                    {props.CountTitle}
                                </p>
                                <div className='Timer'>
                                    <p className='TimerText'>
                                        {props.TimerText}
                                    </p>
                                </div>
                            </div>
                            <Btn BtnText='Book Now' LinkClass="BookLink" BtnStyle='LeftBtn' BtnPath='/booking'/>
                        </div>
                    </section>
     );
}
 
export default ContentCardLeft;